import React from "react";

/* FormField's label row — the label text plus the required marker (strategy
   §25: mark REQUIRED fields with a red “*” and an sr-only “(required)”, never
   optional ones). Internal: not exported from the barrel. FormField renders it
   as a <label> that names one control, and as a <legend> that names a
   `<fieldset>` group, so a single field and a group read the same. */

const LABEL_ROW = "block text-xs font-medium text-pb-text-secondary mb-1.5";

export interface FormFieldLabelProps {
  /** `label` names one control; `legend` names a fieldset group. */
  as: "label" | "legend";
  id?: string | undefined;
  htmlFor?: string | undefined;
  required: boolean;
  children: React.ReactNode;
}

export function FormFieldLabel({
  as,
  id,
  htmlFor,
  required,
  children,
}: FormFieldLabelProps) {
  const marker = required && (
    <>
      <span className="text-pb-red-text ms-0.5" aria-hidden="true">
        *
      </span>
      <span className="sr-only"> (required)</span>
    </>
  );
  if (as === "legend") {
    // `p-0` drops the browser's legend inline padding so the group's name
    // starts on the same edge as a stacked field's label.
    return (
      <legend className={`${LABEL_ROW} p-0`}>
        {children}
        {marker}
      </legend>
    );
  }
  return (
    <label id={id} htmlFor={htmlFor} className={LABEL_ROW}>
      {children}
      {marker}
    </label>
  );
}
